export class AysVirtualClinicSpecialtyDepartment {

    constructor(
        public fabKey: string,
        public id?: string,
        public virtualClinicId?: string,
        public name?: string,
        public fabIntern?: string
    ) {
    }

    public static fromObj(obj: any): AysVirtualClinicSpecialtyDepartment {
        return new AysVirtualClinicSpecialtyDepartment(
            obj.fabKey,
            obj.id,
            obj.virtualClinicId,
            obj.name,
            obj.fabIntern
        );
    }

    public static fromObjArr(objArr: any[]): AysVirtualClinicSpecialtyDepartment[] {
        return objArr.map(AysVirtualClinicSpecialtyDepartment.fromObj);
    }
}
